import { createContext, type FC, type PropsWithChildren, useContext } from "react";
import { createStore, type StoreApi, useStore } from "zustand";

const initialAppRouterStore = {
  pctx: {
    ctx: {} as object,
  },
};

interface AppRouterContextSetters {
  setCtx: (ctx: object) => void;
}

export type AppRouterState = typeof initialAppRouterStore & AppRouterContextSetters;

export const AppRouterContext = createContext<StoreApi<AppRouterState> | null>(null);

export const useAppRouterContext = <T = AppRouterState>(
  selector: (state: AppRouterState) => T = ((s) => s) as (state: AppRouterState) => T
): T => {
  const store = useContext(AppRouterContext);
  if (!store)
    throw new Error(
      "useAppRouterContext must be used within AppRouterContextProvider"
    );
  return useStore(store, selector);
};

const store = createStore<AppRouterState>()((set) => ({
  ...initialAppRouterStore,
  setCtx: (ctx: object) => set({ pctx: { ctx } }),
}));

export const AppRouterContextProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <AppRouterContext.Provider value={store}>{children}</AppRouterContext.Provider>
  );
};
